import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {SelectFieldsTable} from './select-fields.table';
import {JobsDataService} from '../jobs-data.service';
import {UserLanguages} from '../../../shared/models/userLanguages.model';
import {UserExperienceModel} from '../../../shared/models/userExperience.model';
import {UserAbilitiesModel} from '../../../shared/models/userAbilities.model';
import {Options} from 'select2';
import {UploadService} from '../../../shared/upload.service';
import {Select2OptionData} from 'ng-select2';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {DropdownDataTable} from '../../../../crm/shared/dropdown-data.table';
import {AngularEditorConfig} from "@kolkov/angular-editor";
// import { threadId } from 'worker_threads';

@Component({
    selector: 'app-create-job',
    templateUrl: './create-job.component.html',
    styleUrls: ['./create-job.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable, DropdownDataTable]
})

export class CreateJobComponent implements OnInit {
    formResponse: boolean;
    formSent: boolean;
    exampleData = [];
    public multiOptions: Options;
    public singleOption: Options;
    public limitOption: Options;
    // Select Fields Input from Table
    domains: { name: string, subdomains: Array<string> }[] = [];
    domainsArrayValues: Array<any>;
    languages: Array<string> = [];
    years: Array<number>;
    locations = this.locationSelect.Countries;
    city: Array<any> = [];
    locationsArrayValues: Array<any>;
    selectOtherBenefits: Array<string>;
    driveLicense: Array<Select2OptionData>;
    selectContractType: Array<string>;
    selectCareerPossibility: Array<Select2OptionData>;
    selectCategory: Array<Select2OptionData>;
    selectJobAbilities: Array<Select2OptionData>;
    selectExperienceLevel: Array<string>;
    selectWorkProgram: ({ valueName: string; name: string } | string)[];
    selectStudies: ({ valueName: string; name: string } | string)[];
    selectBonus: ({ valueName: string; name: string } | string)[];
    selectWorkSpace: ({ valueName: string; name: string } | string)[];
    selectWeightLiftingRequired: ({ valueName: string; name: string } | string)[];
    selectWorkTemperature: ({ valueName: string; name: string } | string)[];
    // selectUserCommute: ({ valueName: string; name: string } | string)[];

    public sumYears:number =0;
    public totalExp: number;
    public totalExpYears:number;
    public newYear: any=0;

    // Domenii, Subdomenii & Categorii
    selectedDomain = '';
    Domains: any = this.dropdownData.domains;
    departments = this.dropdownData.departments;

    subdomains: any;
    subDomainsArray: any = [];
    jobType: any = [];

    categories: any = [];
    categoriesArray: any = [];

    selectSubdomains: any = [];

    selected: any;

    finalCategories: any = [];

    selectedCategories: any;


    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages = [];
    notCreate: string;
    formError= false;

    // Declare the form model
    public form: {
        userLanguages: UserLanguages[];
        userExperience: UserExperienceModel[];
        jobAbilities: UserAbilitiesModel[];
    };

    // Form Repeaters DTO
    jobDTO: any = [];
    // JobData Object Initialize
    jobData: object;
    idealCandidate: any;
    jobDescription: any;
    benefits: any;
    // Upload File
    selectedFiles?: FileList;
    currentFile?: File;
    // Ranking
    totalFieldsScore = 0;
    criterionFields = [];
    rankingObj = {};
    fieldObj = {};
    criterionFieldsSlugs = [];
    mandatoryObj = {};

    criterion1Field;
    criterion2Field;
    criterion3Field;
    criterion4Field;
    criterion5Field;
    selectedValues = [];

    today = new Date().toLocaleDateString();

    minSal: number = 0;
    maxSal: number = 0;


    @ViewChild('criterion1Score') criterion1Score: ElementRef;
    @ViewChild('criterion2Score') criterion2Score: ElementRef;
    @ViewChild('criterion3Score') criterion3Score: ElementRef;
    @ViewChild('criterion4Score') criterion4Score: ElementRef;
    @ViewChild('criterion5Score') criterion5Score: ElementRef;

    selectFile(event: any): void {
        this.selectedFiles = event.target.files;
    }


    constructor(private http: HttpClient, private createJobService: JobsDataService, private selectFields: SelectFieldsTable,
                private router: Router, private uploadPhoto: UploadService, private dropdownData: DropdownDataTable,
                private locationSelect: SelectLocationTable) {
        // Initialize the template-form component.
        this.form = {
            userLanguages: [],
            userExperience: [],
            jobAbilities: []
        };
        // Initialize Repeater Function
        this.addUserLanguages();
        this.addUserExperience();
        this.addJobAbilities();        
    }

    // wyziwyg fields
    editorConfig: AngularEditorConfig = {
        editable: true,
        translate: 'yes',
        height: 'auto',
        
        minHeight: '200px',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: '',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
            {class: 'arial', name: 'Arial'},
            {class: 'times-new-roman', name: 'Times New Roman'},
        ],
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [
            ['insertImage'],
            ['fontSize'],
            ['insertVideo'],
            ['subscript'],
            ['superscript'],
            ['textColor'],
            ['backgroundColor']
        ]
    };

    // Initialize my array of select items
    ngOnInit() {
        this.jobType = this.dropdownData.jobType;
        this.criterionFieldsSlugs = this.selectFields.criterionFieldsSlugs;
        this.criterionFields = this.selectFields.criterionFields;
        this.languages = this.selectFields.languages;
        this.years = this.selectFields.years;
        this.selectOtherBenefits = this.selectFields.selectOtherBenefits;
        this.driveLicense = this.selectFields.driveLicense;
        this.selectContractType = this.selectFields.selectContractType;
        this.selectExperienceLevel = this.selectFields.selectExperienceLevel;
        this.selectWorkProgram = this.selectFields.selectWorkProgram;
        this.selectStudies = this.selectFields.selectStudies;
        this.selectBonus = this.selectFields.selectBonus;
        this.selectWorkSpace = this.selectFields.selectWorkSpace;
        this.selectCareerPossibility = this.selectFields.selectCareerPossibility;
        this.selectCategory = this.selectFields.selectCategory;
        this.selectJobAbilities = this.selectFields.selectJobAbilities;
        this.selectWeightLiftingRequired=this.selectFields.selectWeightLiftingRequired;
        // this.selectUserCommute=this.selectFields.selectUserCommute;
        this.selectWorkTemperature=this.selectFields.selectWorkTemperature;
        // Select 2 Options
        this.multiOptions = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            multiple: true,
            allowClear: true,
        };
        this.limitOption = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            multiple: true,
            allowClear: true,
            maximumSelectionLength: 5
        };
        this.singleOption = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            allowClear: true
        };

        // Location Loop
        const locationArray = [];
        this.locations.forEach((value) => {
            const country = value.name
            locationArray.push(country);
        });
        this.locationsArrayValues = locationArray;

    }

    changeDomain(domain: any) {
        this.subDomainsArray = [];
        this.selectSubdomains = undefined;
        this.subdomains = this.Domains.find((dmn: any) => dmn.name === domain.target.value).subdomains;
        this.subdomains.forEach(subdomain => {
            this.subDomainsArray.push(subdomain.name);
        })
    }

    changeSubDomain(subdomain: any) {
        this.selected = subdomain;
        this.selectSubdomains = undefined;
        if (this.selected) {
            this.categories = this.Domains
                .find((dmn: any) => dmn.name === this.selectedDomain).subdomains
                .find((subDm: any) => subDm.name === this.selected).categories;
            this.categoriesArray = this.categories;
        }
    }

    changeCountry(country: any) {
        this.city = this.locations.find((loc: any) => loc.name === country).cities;
    }

    // Submit Job Function
    onSubmitJob(jobForm: NgForm) {
        console.log('jobform', jobForm.value);
        this.jobDTO = {
            languages: jobForm.value.foreignLanguage,
            similarExperience: jobForm.value.similarExperience,
            jobAbilities: jobForm.value.jobAbilities,
        }
        // Job Language Repeater
        const jobLanguageValue = [];
        for (const key of Object.keys(this.jobDTO.languages)) {
            const language = this.jobDTO.languages[key];
            jobLanguageValue.push(language);
        }
        // Job Experience Repeater
        const jobSimilarExperienceValue = [];
        for (const key of Object.keys(this.jobDTO.similarExperience)) {
            const simExperience = this.jobDTO.similarExperience[key];
            jobSimilarExperienceValue.push(simExperience);
        }
        // Job Abilities Repeater
        const jobAbilitiesValue = [];
        for (const key of Object.keys(this.jobDTO.jobAbilities)) {
            const jobAbil = this.jobDTO.jobAbilities[key];
            jobAbilitiesValue.push(jobAbil);
        }

        // Ranking fields
        this.rankingObj = {
            // 1
            criterionField1Name: jobForm.value.rankingFields.criterion1Field !== '' ? jobForm.value.rankingFields.criterion1Field : null,
            criterionScore1: jobForm.value.rankingFields.criterion1Score !== '' ? jobForm.value.rankingFields.criterion1Score : null,
            // 2
            criterionField2Name: jobForm.value.rankingFields.criterion2Field !== '' ? jobForm.value.rankingFields.criterion2Field : null,
            criterionScore2: jobForm.value.rankingFields.criterion2Score !== '' ? jobForm.value.rankingFields.criterion2Score : null,
            // 3
            criterionField3Name: jobForm.value.rankingFields.criterion3Field !== '' ? jobForm.value.rankingFields.criterion3Field : null,
            criterionScore3: jobForm.value.rankingFields.criterion3Score !== '' ? jobForm.value.rankingFields.criterion3Score : null,
            // 4
            criterionField4Name: jobForm.value.rankingFields.criterion4Field !== '' ? jobForm.value.rankingFields.criterion4Field : null,
            criterionScore4: jobForm.value.rankingFields.criterion4Score !== '' ? jobForm.value.rankingFields.criterion4Score : null,
            // 5
            criterionField5Name: jobForm.value.rankingFields.criterion5Field !== '' ? jobForm.value.rankingFields.criterion5Field : null,
            criterionScore5: jobForm.value.rankingFields.criterion5Score !== '' ? jobForm.value.rankingFields.criterion5Score : null,
        };

        if (jobForm.value.mandatoryFields.length >= 1) {
            jobForm.value.mandatoryFields.forEach((field, index) => {
                const i = index + 1;
                this.mandatoryObj['fieldName' + i] = field;
            });
        }


        if(this.totalFieldsScore > 100){
            this.notCreate="Criteriile de selecție nu pot depașii 100!";
            this.formError=true;
            window.scrollTo({top: 0, behavior: 'smooth'});

            return
        }else{
            this.formError=false;
        }

        const expirationDays: number = + jobForm.value.expDays;
        // JobData Object Information
        this.jobData = {
            // Job Details Section
            jobTitle: jobForm.value.jobTitle !== '' ? jobForm.value.jobTitle : null,
            idealCandidate: jobForm.value.idealCandidate,
            jobDescription: jobForm.value.jobDescription !== '' ? jobForm.value.jobDescription : null,
            jobEndingDate: '',
            expirationDays,
            videoLink: jobForm.value.videoLink,
            benefits: jobForm.value.benefits,
            country: jobForm.value.country !== '' ? jobForm.value.country : null,
            city: jobForm.value.city !== '' ? jobForm.value.city : null,
            openPositions: jobForm.value.openPositions !== '' ? jobForm.value.openPositions : 0,
            relocationPossibility: jobForm.value.relocationPossibility,
            relocationPackageIncluded: jobForm.value.relocationPackageIncluded,
            workType: jobForm.value.workType !== '' ? jobForm.value.workType : null,
            contractType: jobForm.value.contractType !== '' ? jobForm.value.contractType : null,
            experienceLevel: jobForm.value.experienceLevel !== '' ? jobForm.value.experienceLevel : undefined,
            jobDisponibility: jobForm.value.jobDisponibility !== '' ? jobForm.value.jobDisponibility : undefined,
            activitySector: jobForm.value.activitySector !== '' ? jobForm.value.activitySector : undefined,
            activitySubSector: jobForm.value.activitySubSector !== '' ? jobForm.value.activitySubSector : undefined,
            department: jobForm.value.department !== '' ? jobForm.value.department : undefined,
            category: jobForm.value.category !== '' ? jobForm.value.category : undefined,
            mandatoryCategories: [
                'ADFG', 'Testuts'
            ],
            departmentCoordinator: jobForm.value.departmentCoordinator,
            // Studies Requirements Section
            studies: jobForm.value.studies === '' ? undefined : jobForm.value.studies,
            otherCourses: jobForm.value.otherCourses,
            // Required Skills Section
            foreignLanguage: jobLanguageValue,
            pcKnowledge: jobForm.value.pcKnowledge,
            driverLicense: jobForm.value.driverLicense !== '' ? jobForm.value.driverLicense : undefined,
            availableForTraveling: jobForm.value.availableForTraveling,
            jobAbilities: jobAbilitiesValue,
            // Work Experience Section
            similarExperience: jobSimilarExperienceValue,
            totalExperience: jobForm.value.totalExperience !== '' ? this.totalExp : 0 ,
            //totalExperience: this.sumYears,

            legalWorkPermitMandatory: jobForm.value.legalWorkPermitMandatory,
            // Salary Section
            confidentialSalaryLevel: jobForm.value.confidentialSalaryLevel,
            minimumSalary: jobForm.value.minimumSalaryLevel !== '' ? jobForm.value.minimumSalaryLevel : 0,
            maximumSalary: jobForm.value.maximumSalaryLevel !== '' ? jobForm.value.maximumSalaryLevel : 0,
            bonus: jobForm.value.bonus !== '' ? jobForm.value.bonus : undefined,
            averageBonusValue: jobForm.value.averageBonusValue !== '' ? jobForm.value.averageBonusValue : 0,
            otherBenefits: jobForm.value.otherBenefits !== '' ? jobForm.value.otherBenefits : undefined,
            careerPossibility: jobForm.value.careerPossibility !== '' ? jobForm.value.careerPossibility : undefined,
            // Work Environment Section

            workProgram: jobForm.value.workProgram !== '' ? jobForm.value.workProgram : undefined,
            workSpace: jobForm.value.workSpace !== '' ? jobForm.value.workSpace : undefined,
            // userCommute:jobForm.value.userCommute !== '' ? jobForm.value.userCommute : undefined,
            physicalEffortRequired: {
                type: jobForm.value.physicalType,
                detail: jobForm.value.physicalDetails,
            },
            weightLiftingRequired: jobForm.value.weightLiftingRequired !== '' ? jobForm.value.weightLiftingRequired : undefined,
            workTemperature: jobForm.value.workTemperature !== '' ? jobForm.value.workTemperature : undefined,
            // Mini Interview Section
            miniInterview: jobForm.value.miniInterview,
            // Ranking
            candidateMatch: this.rankingObj,
            mandatoryFields: this.mandatoryObj,
        }
        // && ((+this.totalFieldsScore === 100) || (+this.totalFieldsScore === 0)) && (this.minSal <= this.maxSal)
        if (jobForm.valid ) {
            // Create Job Service
            this.createJobService.postCreatedJob(this.jobData).subscribe(responseData => {
                this.formResponse = true;
                this.formSent = true;
                // Upload Service for Upload File
                this.uploadPhoto.upload(this.selectedFiles, '/uploadJobImage?jobId=' + responseData.reason);
                window.scrollTo({top: 0, behavior: 'smooth'});
                // After 5sec Redirect User To A Specific Page
                setTimeout(() => {
                    // Redirect To Your Created Job
                    this.router.navigate(['/job/' + responseData.reason]);
                }, 5000)
            }, (error:any) => {
                console.log('EROARE',error.error.reason);
                if(error.error.reason==="notAllowed" || error.error.reason==="noCompanyFound"){
                    this.notCreate="Nu se pot crea job-uri fara a avea o companie!";
                    this.formError=true;
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
                else{
                this.formResponse = false;
                this.formSent = true;
                window.scrollTo({top: 0, behavior: 'smooth'});
                }
                
                
            })
        } else {
            console.log(jobForm);
            this.formResponse = false;
            this.formSent = true;
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }

    // Repeater
    trackByFunction(index, item) {
        return item.index;
    }

    // Add The First Set of Inputs For Languages
    addUserLanguages() {
        this.form.userLanguages.push({
            id: Date.now(),
            language: '',
            level: ''
        });
    }

    // Add The First Set of Inputs For Experience
    addUserExperience() {
        this.form.userExperience.push({
            id: Date.now(),
            department: '',
            year: 0
        })
        
    }
    //calculate the sum of the years of experience 
    insertedYear(newValue: any) {
        this.sumYears=this.sumYears+newValue;
        
        console.log(this.sumYears);
      }

      verifyTotalExperience(insertedValue: any){
        this.totalExp=insertedValue;
        if(this.totalExp > this.sumYears){
            
            this.totalExp=this.sumYears;
        }else{
            console.log("suma totala experienta:");
            console.log(this.totalExp);
        }
      }

    

    // Add The First Set of Inputs For Abilities
    addJobAbilities() {
        this.form.jobAbilities.push({
            id: Date.now(),
            abilityName: '',
            abilityDescription: '',
            abilityLevel: ''
        })
    }

    // On Click Remove The Selected Inputs For Languages
    removeUserLanguages(index: number) {
        this.form.userLanguages.splice(index, 1);
    }

    // On Click Remove The Selected Inputs For Experience
    removeUserExperience(index: number) {
        this.form.userExperience.splice(index, 1);
    }

    // On Click Remove The Selected Inputs For Abilities
    removeJobAbilities(index: number) {
        this.form.jobAbilities.splice(index, 1)
    }

    changeScore(e) {
        this.totalFieldsScore = this.criterion1Score['value'] + this.criterion2Score['value'] +
            this.criterion3Score['value'] + this.criterion4Score['value'] + this.criterion5Score['value'];
        // @ts-ignore
        if (this.totalFieldsScore === 'null') {
            this.totalFieldsScore = 0;
        }
    }

    fieldSelected(e: Event) {
        this.selectedValues = [this.criterion1Field, this.criterion2Field, this.criterion3Field, this.criterion4Field, this.criterion5Field];

        this.selectedValues.forEach(field => {
            const selectedField = this.criterionFieldsSlugs.filter((criterion, index) => {
                    if (criterion.id === field) {
                        criterion.disabled = true;
                        this.criterionFieldsSlugs.splice(index, 1);
                        return criterion;
                    }
                }
            )[0];
            if (selectedField !== undefined) {
                this.criterionFieldsSlugs.push(selectedField);
            }
        })
        // this.selectedValues.forEach(field => {
        //     if(this.criterionFields.includes(field)){
        //         const index = this.criterionFields.indexOf(field, 0);
        //         if (index > -1) {
        //             this.criterionFields.splice(index, 1);
        //         }
        //
        //     }
        // })
    }

    select2Open() {


    }
}
